"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetNotLiveVideoSource = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("@studio/constants");
var _utils = require("./utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Reset unhidden video source to seek position 0
 *
 * @param liveSources
 * @param sources
 * @param dispatch
 * @param updateSource updateSource function
 * @returns {*}
 */
var resetNotLiveVideoSource = exports.resetNotLiveVideoSource = function resetNotLiveVideoSource(liveSources, sources, serverTimeDelta, dispatch, updateSource) {
  var sourceToUpdate = null;
  var resetSources = sources.map(function (source) {
    var _id = source._id,
      type = source.type,
      hidden = source.hidden;
    if (type === _constants.VIDEO_FILE && !hidden && !liveSources.includes(_id)) {
      source.value = _objectSpread(_objectSpread({}, source.value), {}, {
        seek: 0,
        isPlaying: true,
        startedOn: (0, _utils.getStartedOn)(true, serverTimeDelta)
      });
      sourceToUpdate = source;
      return source;
    }
    return source;
  });
  if (sourceToUpdate) {
    var _sourceToUpdate = sourceToUpdate,
      _id = _sourceToUpdate._id,
      value = _sourceToUpdate.value;
    dispatch(updateSource(_id, {
      value: value
    }));
  }
  return resetSources;
};